module.exports = __webpack_public_path__ + "static/img/liyou-ben.b5bea32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/liyou-ben.jpg
// module id = tlaZ
// module chunks = 0